export enum FileExtTypeEnum {
  PDF = 'pdf',
  XLSX = 'xlsx',
  XLS = 'xls',
  DOCX = 'docx',
  DOC = 'doc',
  ZIP = 'zip',
}
